import React, { useState } from 'react';
import vanu from '../apis/vanu';

import { Dropdown } from 'semantic-ui-react'


const Geocoder = ({ onGeocodeSearch }) => {

    const [places, setPlaces] = useState([]);

    const onPlacenameChange = async (e, value) => {
        let place = value.searchQuery;
        let options = [];

        // if format is float,float then we have lon,lat coordinates. Otherwise is a place name
        if (place.split(',').length === 2) {
            const pairs = place.split(',');
            if (!isNaN(pairs[0]) & !isNaN(pairs[1])) {
                options.push({ key: 0, text: `${pairs[0]},${pairs[1]}`, value: `${pairs[0]},${pairs[1]}` });
                setPlaces(options);
            }
        } else {
            console.log(`Searching for a place named ${place}`);
            const response = await vanu.get(`/places/search/${place}}`, {});
            response.data.forEach(place_res => {
                options.push({ key: place_res.id, text: place_res.name, value: `${place_res.lon},${place_res.lat}` });
            });
            setPlaces(options);
        }
    }

    const handleOnChange = (e, data) => {
        onGeocodeSearch(data.value);
    }

    return (
        <div className="ui segment" data-tut="reactour__geocoder">
            <Dropdown
                    search
                    selection
                    fluid
                    onSearchChange={onPlacenameChange}
                    onChange={handleOnChange}
                    options={places}
                    placeholder='Type a place to search or the coordinates of a point as lon,lat...'
                />
        </div>
    );
};

export default Geocoder;